import { ReportConfig } from "../definitions";

const affiliatePaidReport: ReportConfig = {
  id: "affiliatePaidReport",
  name: "Affiliate Paid Report",
  options: [
    { name: "startDate", label: "Start Date", dataType: "date", defaultValue: "$YEAR-01-01" },
    { name: "endDate", label: "End Date", dataType: "date", defaultValue: "$YEAR-$MONTH-$DAY" },
    {
      name: "affiliate",
      label: "Affiliate",
      dataType: "select-dynamic",
      defaultValue: 137,
      optionsDataSource: {
        sql: `
      SELECT 0 AS ID, 'Select an affiliate' AS [Name], 0 AS [SortOrder]
      UNION ALL
      SELECT ID, [Name], 1 as [SortOrder]
      FROM dbo.affiliate
      WHERE IsDeleted = 0
      ORDER BY [SortOrder], [Name]`,
        returnType: "options",
      },
    },
  ],
  layout: [
    {
      items: [
        {
          id: "item-1",
          title: "Policy count",
          widgetType: "figure",
          dataSource: {
            sql: `
if @affiliate = 0
BEGIN
  SELECT '-' as [Value]
  RETURN
END
ELSE
BEGIN

SELECT COUNT(DISTINCT a.PolicyNumber) as [Value]
FROM awu.Application a
    INNER JOIN awu.ApplicationBroker ab On a.ID = ab.ApplicationID
    CROSS APPLY(SELECT TOP 1 BrokerID,AffiliateID FROM awu.ApplicationBroker ab WHERE a.ID = ab.ApplicationID) ac
    LEFT JOIN [awu].[ApplicationStatus] [st] ON a.[ApplicationStatusID] = st.[ID]
    INNER JOIN dbo.Affiliate af on ac.AffiliateID = af.id
WHERE a.PaidOrClosedDate BETWEEN @startDate AND @endDate
    AND st.[ApplicationStatusCode] in ('2', '3', 'P')
    AND st.[ScenarioTypeCode] = 'F'
    AND af.ID = @affiliate
    AND a.IsDeleted = 0
    AND (@_branch = 0 OR a.BranchTypeID = @_branch)
END
            `,
            returnType: "scalar",
            returnExpression: "0.Value",
          },
          options: { color: "blue" },
        },
        {
          id: "item-2",
          title: "Total Premium",
          widgetType: "figure",
          dataSource: {
            sql: `
if @affiliate = 0
BEGIN
  SELECT '-' as [Value]
  RETURN
END
ELSE
BEGIN

SELECT SUM(ap.AnnualizedPremium * ab.CommissionPercent) as [Value]
FROM awu.Application a
    INNER JOIN awu.ApplicationBroker ab On a.ID = ab.ApplicationID
    CROSS APPLY(SELECT TOP 1 BrokerID,AffiliateID FROM awu.ApplicationBroker ab WHERE a.ID = ab.ApplicationID) ac
    LEFT JOIN [awu].[ApplicationStatus] [st] ON a.[ApplicationStatusID] = st.[ID]
    INNER JOIN dbo.Affiliate af on ac.AffiliateID = af.id
    INNER JOIN awu.ApplicationPremium ap on a.ID = ap.ApplicationID
WHERE a.PaidOrClosedDate BETWEEN @startDate AND @endDate
    AND st.[ApplicationStatusCode] in ('2', '3', 'P')
    AND st.[ScenarioTypeCode] = 'F'
    AND af.ID = @affiliate
    AND a.IsDeleted = 0
    AND (@_branch = 0 OR a.BranchTypeID = @_branch)
END
            `,
            returnType: "scalar",
            returnExpression: "0.Value",
            returnExpressionFormat: {
              type: "currency",
              name: null,
            },
          },
          options: { color: "blue" },
        },
      ],
    },
    {
      items: [
        {
          id: "data-table",
          title: "",
          widgetType: "table",
          columns: [
            { name: "Company", type: "string" },
            { name: "Broker", type: "string" },
            { name: "Client", type: "string" },
            { name: "Policy Number", type: "string", summary: "distinct" },
            { name: "Carrier", type: "string" },
            { name: "Product", type: "string" },
            { name: "Status", type: "string" },
            { name: "Placed", type: "date" },
            { name: "Mode", type: "string" },
            { name: "Premium", type: "currency", summary: "sum", align: "right" },
          ],
          dataSource: {
            sql: `
if @affiliate = 0
BEGIN
  SELECT 'You must select an affiliate' AS Message
  RETURN
END
ELSE
BEGIN

SELECT
    c.Name as [Company],
    b.FirstName + ' ' + b.lastname AS [Broker],
    CASE WHEN a.FirstName is null then
        ne.FirstName + ' ' + ne.LastName
    ELSE
        a.Firstname+ ' ' + a.lastname
    END AS [Client],
    a.PolicyNumber,
    cr.[Type] AS [Carrier],
    pl.[Name] AS [Product],
    ast.Description AS [Status],
    a.PaidOrClosedDate [Placed],
    CASE WHEN ap.mode = 'A' THEN 'Annual'
        WHEN ap.mode = 'Q' THEN 'Quarterly'
        WHEN ap.mode = 'SA' THEN 'Semi-Annual'
        WHEN ap.mode = 'M' THEN 'Monthly'
        WHEN ap.mode = '1' THEN 'One Pay'
    END AS [Mode],
    ap.AnnualizedPremium * ab.CommissionPercent AS [Premium],
    ab.CommissionLevel,
  0 as Section
FROM awu.Application a
    INNER JOIN awu.ApplicationBroker ab On a.ID = ab.ApplicationID
    CROSS APPLY
    (
    	SELECT TOP 1 BrokerID,AffiliateID FROM awu.ApplicationBroker ab WHERE a.ID = ab.ApplicationID
    ) ac
    LEFT JOIN [awu].[ApplicationStatus] [st] ON a.[ApplicationStatusID] = st.[ID]
    INNER JOIN awu.ApplicationPremium ap on a.ID = ap.ApplicationID
    INNER JOIN dbo.Broker b on ab.Brokerid = b.ID
    INNER JOIN dbo.Carriertype cr on a.CarrierID = cr.ID
    INNER JOIN awu.[Plan] pl on a.PlanID = pl.ID
    INNER JOIN awu.ApplicationStatus ast on a.ApplicationStatusID = ast.id
    INNER JOIN dbo.Affiliate af on ac.AffiliateID = af.id
    LEFT JOIN awu.ApplicationGroupPolicy gp ON a.id=gp.ApplicationID
    OUTER APPLY (
        SELECT TOP 1 FirstName, LastName
        FROM awu.ExternalInsured
        WHERE a.GroupID=ExternalInsured.ApplicationID
        AND gp.ExternalNumber=ExternalInsured.ExternalNumber
    ) ne
    OUTER APPLY (SELECT TOP 1 * FROM dbo.Company WHERE id = b.CompanyID) as c

WHERE a.PaidOrClosedDate BETWEEN @startDate AND @endDate
    AND st.[ApplicationStatusCode] in ('2', '3', 'P')
    AND st.[ScenarioTypeCode] = 'F'
    AND af.ID = @affiliate
    AND (@_branch = 0 OR a.BranchTypeID = @_branch)

UNION

SELECT
  null,
  null,
  null,
  CAST(COUNT(DISTINCT CASE WHEN a.PolicyNumber IS NULL THEN CAST(a.ID AS VARCHAR) ELSE a.PolicyNumber END) AS VARCHAR),
  null,
  null,
  null,
  null,
  null,
  SUM(ap.AnnualizedPremium * ab.CommissionPercent) as [Value],
  null,
  1 as Section
FROM awu.Application a
  INNER JOIN awu.ApplicationBroker ab On a.ID = ab.ApplicationID
  CROSS APPLY
  (
    SELECT TOP 1 BrokerID,AffiliateID FROM awu.ApplicationBroker ab WHERE a.ID = ab.ApplicationID
  ) ac
  LEFT JOIN [awu].[ApplicationStatus] [st] ON a.[ApplicationStatusID] = st.[ID]
  INNER JOIN awu.ApplicationPremium ap on a.ID = ap.ApplicationID
  INNER JOIN dbo.Broker b on ab.Brokerid = b.ID
  INNER JOIN dbo.Carriertype cr on a.CarrierID = cr.ID
  INNER JOIN awu.[Plan] pl on a.PlanID = pl.ID
  INNER JOIN awu.ApplicationStatus ast on a.ApplicationStatusID = ast.id
  INNER JOIN dbo.Affiliate af on ac.AffiliateID = af.id
  LEFT JOIN awu.ApplicationGroupPolicy gp ON a.id=gp.ApplicationID
  OUTER APPLY (
      SELECT TOP 1 FirstName, LastName
      FROM awu.ExternalInsured
      WHERE a.GroupID=ExternalInsured.ApplicationID
      AND gp.ExternalNumber=ExternalInsured.ExternalNumber
  ) ne
  OUTER APPLY (SELECT TOP 1 * FROM dbo.Company WHERE id = b.CompanyID) as c

WHERE a.PaidOrClosedDate BETWEEN @startDate AND @endDate
  AND st.[ApplicationStatusCode] in ('2', '3', 'P')
  AND st.[ScenarioTypeCode] = 'F'
  AND af.ID = @affiliate
  AND (@_branch = 0 OR a.BranchTypeID = @_branch)

ORDER BY Section, Placed, PolicyNumber, CommissionLevel
END
            `,
            returnType: "table",
          },
          options: { summaryInData: true, zebraFieldIndex: [3, 2] },
        },
      ],
    },
  ],
};

export default affiliatePaidReport;
